import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
import { TextField, SelectField } from 'redux-form-material-ui';
import { compose, getContext } from 'recompose';
import { MenuItem } from 'material-ui';
import _ from 'lodash';
import humanize from 'humanize-string';
import { triggerTypesMap } from 'dash-front/triggerConstants';
import { EventPicker2, TournamentPickerV2, TeamPicker2 } from './pickers';
import { presence } from 'dash-front/helpers/validation';
import { getFieldPath } from '../helpers';

const FIELDS_TO_DISABLE = ['sportId'];

const TournamentPickerWithSport = compose(
    getContext({
        _reduxForm: PropTypes.object
    }),
    connect((state, { _reduxForm: { form, sectionPrefix } }) => ({
        sport: formValueSelector(form)(state, getFieldPath(sectionPrefix, 'sportId'))
    }))
)(TournamentPickerV2);

const withSportAndTtId = compose(
    getContext({
        _reduxForm: PropTypes.object
    }),
    connect((state, { _reduxForm: { form, sectionPrefix } }) => ({
        sport: formValueSelector(form)(state, getFieldPath(sectionPrefix, 'sportId')),
        tournamentId: formValueSelector(form)(state, getFieldPath(sectionPrefix, 'ttId'))
    }))
);

const EventPickerWithProps = withSportAndTtId(EventPicker2);
const TeamPickerWithProps = withSportAndTtId(TeamPicker2);

const resolveField = (field, index, allRequired) => {
    const { name, required, picker: pickerType, values: options, label } = field;
    const validate = required || allRequired ? presence : _.noop;
    const disabled = FIELDS_TO_DISABLE.some(e => e === name);
    switch (pickerType) {
        case 'tournament_picker':
            return (
                <TournamentPickerWithSport name={name} style={{ width: 240 }} validate={validate} disabled={disabled} />
            );
        case 'event_by_date_picker':
            return <EventPickerWithProps name={name} style={{ width: 270 }} validate={validate} disabled={disabled} />;
        case 'team_picker':
            return (
                <TeamPickerWithProps
                    name={name}
                    style={{ width: 200 }}
                    validate={validate}
                    floatingLabelText={label || humanize(name)}
                    disabled={disabled}
                />
            );
        case 'enum_picker':
            return (
                <Field
                    name={name}
                    validate={validate}
                    disabled={disabled}
                    floatingLabelText={label || humanize(name)}
                    style={{ width: 200 }}
                    component={SelectField}
                >
                    {options.map(option => (
                        <MenuItem primaryText={option.label} value={option.value} key={option.value} />
                    ))}
                </Field>
            );
        default:
            return (
                <Field
                    name={name}
                    validate={validate}
                    disabled={disabled}
                    floatingLabelText={label || humanize(name)}
                    style={{ width: 120 }}
                    component={TextField}
                />
            );
    }
};

const ConditionForm = ({ triggerType, allRequired = false }) => {
    const selected = _.get(triggerTypesMap, [triggerType, 'conditions']);
    if (!triggerType || !Array.isArray(selected)) {
        return null;
    }
    return (
        <div style={{ display: 'flex' }}>
            {selected.map((field, index) => (
                <span key={field.name} style={{ display: 'flex', alignItems: 'baseline' }}>
                    {resolveField(field, index, allRequired)}
                </span>
            ))}
        </div>
    );
};

ConditionForm.propTypes = {
    triggerType: PropTypes.string,
    allRequired: PropTypes.bool
};

export default ConditionForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/ConditionForm.js
 **/